import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss']
})
export class ColorPickerComponent {
  @Input() heading: string;
  @Input() color: string;
  @Output() event: EventEmitter<string> = new EventEmitter<string>();

  public show = false;
  public defaultColors: string[] = [
    '#ffffff',
    '#ff9900',
    '#004eff',
    '#E53935',
    '#7CB342',
    '#F4511E',
    '#039BE5',
    '#D81B60',
    '#C0CA33',
    '#6D4C41',
    '#8E24AA',
    '#00ACC1',
    '#FDD835',
    '#5E35B1',
    '#00897B',
    '#FFB300',
    '#3949AB',
    '#43A047',
    '#1E88E5',
    '#404040',
    '#a0a0a0',
    '#c0c0c0',
    '#000000'
  ];

  constructor() { }

  public changeColor(color: string): void {
    this.color = color;
    this.event.emit(this.color);
    this.show = false;
  }

  public changeColorManual(color: string): void {
    const isValid = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);

    if (isValid) {
      this.color = color;
      this.event.emit(this.color);
    }
  }

  public toggleColors(): void {
    this.show = !this.show;
  }
}
